import { type Invoice } from '@constants'
import { type CheckoutOrder } from '@hooks-api/types/dataModel/orders'
import { Radio } from '@mui/material'
import { HStack } from '@pets-ui/HStack/HStack'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { VStack } from '@pets-ui/VStack/VStack'
import * as stylex from '@stylexjs/stylex'
import { type ReactNode } from 'react'
import { Controller, useFormContext } from 'react-hook-form'

const radioSxProps = {
  sx: {
    'color': colors.grey400,
    '&.Mui-checked': {
      color: colors.black,
    },
  },
}

const dialogAndDrawer = stylex.create({
  radio: {
    padding: 16,
    borderColor: colors.grey300,
    borderRadius: 4,
    borderStyle: 'solid',
    borderWidth: 1,
    alignItems: 'center',
    backgroundColor: colors.white,
    cursor: 'pointer',
  },
  invoice: {
    flex: '1',
  },
})

export const InvoiceOption = ({ value, label, children, checked, onChange }: {
  value: Invoice
  label: string
  children?: ReactNode
  checked: boolean
  onChange: (value: Invoice) => void
}) => (
  <HStack rootStyle={dialogAndDrawer.radio} gap={2} onClick={() => onChange(value)}>
    <Controller
      control={useFormContext<CheckoutOrder>().control}
      name="receipt_type"
      rules={{ required: '必填欄位' }}
      render={({ field }) => (
        <Radio
          {...field}
          {...radioSxProps}
          size="small"
          value={value}
          checked={checked}
        />
      )}
    />
    <VStack rootStyle={dialogAndDrawer.invoice} gap={2}>
      <Text color={colors.black}>
        {label}
      </Text>
      {checked && children}
    </VStack>
  </HStack>
)
